import { Component } from 'react';

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error('[ErrorBoundary]', error, info.componentStack);
  }

  render() {
    if (!this.state.error) return this.props.children;

    return (
      <div style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'var(--navy, #0b0f1a)',
        padding: '2rem',
      }}>
        <div style={{
          background: 'var(--panel, rgba(255,255,255,0.04))',
          border: '1px solid var(--border, rgba(255,255,255,0.08))',
          borderRadius: '12px',
          padding: '2.5rem',
          maxWidth: '480px',
          width: '100%',
          textAlign: 'center',
        }}>
          <div style={{ fontSize: '2.5rem', marginBottom: '1rem' }}>⚠️</div>
          <h1 style={{ color: 'var(--white, #fff)', fontSize: '1.25rem', marginBottom: '0.75rem' }}>
            Etwas ist schiefgelaufen
          </h1>
          <p style={{ color: 'var(--muted, #8892a4)', lineHeight: 1.6, marginBottom: '1.75rem' }}>
            Ein unerwarteter Fehler ist aufgetreten. Lade die Seite neu — falls das Problem weiterhin besteht,
            wende dich an den Support.
          </p>

          {process.env.NODE_ENV === 'development' && (
            <pre style={{
              background: 'rgba(0,0,0,0.3)',
              border: '1px solid rgba(255,255,255,0.06)',
              borderRadius: '6px',
              padding: '0.75rem',
              fontSize: '0.72rem',
              color: 'var(--magenta, #e040fb)',
              textAlign: 'left',
              overflowX: 'auto',
              marginBottom: '1.75rem',
              whiteSpace: 'pre-wrap',
              wordBreak: 'break-word',
            }}>
              {this.state.error.toString()}
            </pre>
          )}

          <button
            onClick={() => window.location.reload()}
            style={{
              background: 'var(--cyan, #00e5ff)',
              color: 'var(--navy, #0b0f1a)',
              border: 'none',
              borderRadius: '6px',
              padding: '0.65rem 1.5rem',
              fontSize: '0.9rem',
              fontWeight: 600,
              cursor: 'pointer',
              width: '100%',
            }}
          >
            Seite neu laden
          </button>
        </div>
      </div>
    );
  }
}
